import { render, staticRenderFns } from "./CalendarComponent.vue?vue&type=template&id=1f0895de&scoped=true"
import script from "./CalendarComponent.vue?vue&type=script&lang=js"
export * from "./CalendarComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f0895de",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1f0895de')) {
      api.createRecord('1f0895de', component.options)
    } else {
      api.reload('1f0895de', component.options)
    }
    module.hot.accept("./CalendarComponent.vue?vue&type=template&id=1f0895de&scoped=true", function () {
      api.rerender('1f0895de', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Calendar/CalendarComponent.vue"
export default component.exports